var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"account-coin"},[_c('img',{staticClass:"coin-icon",attrs:{"src":require("./images/coin.png"),"alt":"余额"}}),_vm._v(" "+_vm._s(_vm.coin)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }